import { put, call } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { doShowLoading, doHideLoading, doShowResponse } from '../actions/ui';
import { doSaveVendorInfo } from '../actions/vendor';
import { requestWhitelistVendedor } from '../api/vendedor';

// TODO Essa etapa é uma POC e deve ser refatorada no futuro
function* handleVendorSession(action) {
  const { payload } = action;
  const { codigoPromotor, channel } = payload;

  yield put(doShowLoading());

  try {
    const response = yield call(requestWhitelistVendedor, codigoPromotor);
    const { adabas } = response.data;
    const data = {
      codigoPromotor,
      channel,
      adabas,
    };
    yield put(doSaveVendorInfo(data));
    yield put(push('/vendas'));
    yield put(doHideLoading());
  } catch (e) {
    let errorMessage = 'Falha ao realizar login do vendedor';
    if (e.response.status === (401 || 403)) {
      errorMessage = e.response.data.message;
    }

    yield put(doShowResponse('error', errorMessage));
    yield put(doHideLoading());
  }
}

export { handleVendorSession };
